import { getStateSetter } from './utils';
import * as Sentry from '@sentry/browser';
import { toast } from '@tokenyico/design-system';

export const formInitialState = {
  isSubmitting: false,
  error: null,
  success: null,
};

const setState = getStateSetter('ui.form');

const errorNotification = (error) => {
  toast.error(
    'Error',
    error instanceof Error || error instanceof Object ? error.message : error,
    true,
  );
  const exception = error.error || error.message || error.originalError || error;
  Sentry.captureException(exception);
};

const successNotification = (success, userDismissOrTimeout = false) => {
  toast.success('Success', success, userDismissOrTimeout);
};

export const formActions = () => ({
  setError: (state, value) => {
    console.error(value);
    errorNotification(value);
    return setState(state, { error: value });
  },
  setSuccess: (state, value, userDismissOrTimeout) => {
    successNotification(value, userDismissOrTimeout);
    return setState(state, { success: value });
  },
  setIsSubmitting: (state, value) => setState(state, { isSubmitting: value }),
  resetFormState: (state) => setState(state, formInitialState),
});
